module.exports = __webpack_public_path__ + "img/zytb-logo-hover.c2d251ed.png";